const typographyformCreateUser = {
  text: 'New User Registration'
};

export default typographyformCreateUser;
